import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintenanceManGetChargeTimeConf(params) {
  return maintainRequest({
    url: "/device/maintenanceMan/chargingTimeConf/getChargeTimeConf",
    params,
  });
}
